import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { CollectionView } from 'common';
import { DEPRECATED_QUERY_KEYS, queryClient } from '@src/query';
import { deleteCollection } from './api';
import { setQueryCollections } from './useQueryCollections';

export const useMutationCollectionDelete = () => useMutation<void, ApiError, { collectionId: string }>({
  mutationFn: ({ collectionId }) => deleteCollection(collectionId),
  onSuccess: async (_, { collectionId }) => {
    const current = queryClient.getQueryData<CollectionView[]>([DEPRECATED_QUERY_KEYS.COLLECTIONS]) ?? [];
    setQueryCollections(current.filter((c) => c._id !== collectionId));
    queryClient.invalidateQueries({ queryKey: [DEPRECATED_QUERY_KEYS.COLLECTIONS] });
  },
});
